import { render } from "./WeekDays.vue?vue&type=template&id=a5a27e8c&scoped=true&bindings={\"weekDays\":\"props\",\"dark\":\"props\"}"
import script from "./WeekDays.vue?vue&type=script&lang=js"
export * from "./WeekDays.vue?vue&type=script&lang=js"

import "./WeekDays.vue?vue&type=style&index=0&id=a5a27e8c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a5a27e8c"

export default script